import { createApp } from 'vue';
import App from './App.vue';
import axiosConfig from '@/utils/AxiosConfig';
import './main.css';
import router from './router/index';
import { createPinia } from 'pinia';

const app = createApp(App),
 pinia = createPinia();
app.config.devtools = true;

app
  .use(pinia)
  .use(router)
  .use(axiosConfig.vueAxios, { $api: axiosConfig.api, $auth: axiosConfig.auth })
  .mount('#app');
